<template>
  <ui-card name="user.profile" rounded class="has-shadow">
    <div class="user-media media">
      <div class="media-left">
        <i class="material-icons icon is-large">person</i>
      </div>
      <div class="media-content">
        <p>
          {{ $t('ui.labels.user_id') }}:
          <span id="user-id">{{ user.id }}</span>
        </p>
      </div>
      <ui-copy-button v-if="user.id" :value="user.id" />
    </div>
    <div class="user-overview">
      <div class="level">
        <div class="level-left">{{ $t('user.profile.install_date') }}</div>
        <div class="level-right">{{ install }}</div>
      </div>
      <div class="level">
        <div class="level-left">{{ $t('user.profile.os.title') }}</div>
        <div class="level-right">
          <i v-if="os.icon" class="os-icon mdi" :class="`mdi-${os.icon}`"></i>
          <span>{{ os.name }}</span>
        </div>
      </div>
    </div>
    <div class="user-locations">
      <div v-if="locations.length">
        <div class="level" v-for="item in locations" :key="item.significance">
          <div class="level-left">
            <span>{{ $t(`user.profile.locations.${item.significance}`) }}</span>
          </div>
          <div class="level-right">
            <span>{{ item.city }}</span>
            <span v-if="item.country">, {{ item.country }}</span>
          </div>
        </div>
      </div>
      <p v-else>{{ t('user.profile.locations.no_data') }}</p>
    </div>
  </ui-card>
</template>

<script>
import * as moment from 'moment';
import { get } from 'lodash';

export default {
  computed: {
    user() {
      return this.$store.state.user;
    },

    install() {
      return moment(this.user.created_at).format('Do MMM, YYYY');
    },

    os() {
      const os = get(this.user, 'device.os');
      const lookup = {
        ios: {
          name: this.$t('user.profile.os.ios'),
          icon: 'apple',
        },
        android: {
          name: this.$t('user.profile.os.android'),
          icon: 'android',
        },
      };

      return os
        ? lookup[os] || os
        : { name: this.$t('user.profile.os.unknown'), icon: null };
    },

    locations() {
      const home = this.parseLocation('home');
      const work = this.parseLocation('work');

      const { active_moments } = this.user;
      const cityMoment = active_moments.find(
        moment => moment.type === 'CityMoment'
      );
      const countryMoment = active_moments.find(
        moment => moment.type === 'CountryMoment'
      );
      const city = get(cityMoment, 'city_name');
      const country = get(countryMoment, 'country_name');
      const current = {
        city,
        country,
        significance: 'other',
      };

      return [home, work, current];
    },
  },

  methods: {
    parseLocation(significance) {
      const location = this.user.locations.find(
        location => location.significance === significance
      );

      const city = get(location, 'address.city');
      const country = get(location, 'address.country');

      return { significance, city, country };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.user-profile {
  font-size: 0.875rem;
  line-height: 1.29;
}

.user-media,
.user-overview,
.user-locations {
  padding: 1rem;
}

.user-media {
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 0;
  }

  & + .user-overview {
    padding-top: 0;
  }

  .media-left {
    i {
      font-size: 0.875rem;
      background: $blue;
      border-radius: 100%;
      color: $white;
    }
  }

  .media-content {
    font-size: 0.875rem;
  }
}

.level {
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
}

.level-left {
  color: rgba($black, 0.72);

  i {
    display: flex;
    margin-right: 0.75rem;
    font-size: 0.875rem;
  }
}

.level-right {
  font-weight: $weight-medium;

  a {
    color: $blue;
  }
}

.os-icon {
  display: flex;
  margin-right: 0.5rem;
  font-size: $size-small;

  &.mdi-android {
    color: #72c516;
  }
}

.user-overview {
  & + .user-locations {
    border-top: solid 1px rgba($black, 0.08);
  }
}

#user-id {
  font-weight: $weight-medium;
  color: rgba($black, 0.87);
}

.card-header-link {
  top: 2px;
}
</style>
